import { HttpRequest, HttpInterceptorFn, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

export const languageInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const translateService = inject(TranslateService);

  const lang = translateService.currentLang;

  let newReq = req;

  if (lang) {
    newReq = req.clone({
      headers: req.headers.set('Accept-Language', lang),
    });
  }

  return next(newReq);
};
